import { render } from "./ExchangeDetail.vue?vue&type=template&id=71fe9ea9"
import script from "./ExchangeDetail.vue?vue&type=script&lang=js"
export * from "./ExchangeDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__